import { DataSource } from './data-source';
export class ImageSource extends DataSource {}
//# sourceMappingURL=image-source.js.map